import { defineMessages } from 'react-intl';

export const messages: {
	statusUpdateTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusUpdateTitle: {
		id: 'search-page.mercury.focus-area-update.title',
		defaultMessage: 'Update for {focusAreaName}',
		description: 'Focus area status update title',
	},
});
